// Angle Coach: lightweight client-side quality check (lighting + blur) before AI preview.
export const analyzeImageQuality = (file) =>
  new Promise((resolve) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      try {
        const W = 160;
        const scale = W / img.width;
        const H = Math.max(1, Math.round(img.height * scale));
        const canvas = document.createElement("canvas");
        canvas.width = W;
        canvas.height = H;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0, W, H);
        const { data } = ctx.getImageData(0, 0, W, H);

        const lum = new Float32Array(W * H);
        let sum = 0;
        for (let i = 0, p = 0; i < data.length; i += 4, p++) {
          const l = 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
          lum[p] = l;
          sum += l;
        }
        const mean = sum / (W * H);

        // Sharpness via variance of a Laplacian filter
        let lSum = 0, lSumSq = 0, n = 0;
        for (let y = 1; y < H - 1; y++) {
          for (let x = 1; x < W - 1; x++) {
            const idx = y * W + x;
            const lap = 4 * lum[idx] - lum[idx - 1] - lum[idx + 1] - lum[idx - W] - lum[idx + W];
            lSum += lap;
            lSumSq += lap * lap;
            n++;
          }
        }
        const lapVar = lSumSq / n - (lSum / n) ** 2;

        URL.revokeObjectURL(url);
        const issues = [];
        if (mean < 50) issues.push("it looks too dark — try brighter, even lighting");
        else if (mean > 215) issues.push("it looks overexposed — reduce glare or brightness");
        if (lapVar < 55) issues.push("it looks blurry — hold steady and tap to refocus");
        resolve({ mean, lapVar, issues });
      } catch (e) {
        URL.revokeObjectURL(url);
        resolve({ issues: [] });
      }
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      resolve({ issues: [] });
    };
    img.src = url;
  });
